<div class="agency">
    <!--breadcrumb section start -->
    <section class="breadcrumb-section-main inner-2 breadcrumb-section-sm">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="breadcrumb-contain ">
                        <div>
                            <h2 class="breadcrumb-txt">Checkout</h2>
                        </div>
                        <div>
                            <ul>

                                <li><a href="#">Kauf abschließen</a></li>
                                <li><a href="#"><i class="fa fa-angle-double-right"></i>{{ configState.selectedTable }}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--breadcrumb section end -->
    <section class="section-b-space">
        <div class="container padding-cls">
            <div class="checkout-page">
                <div class="checkout-form">
                    <form [formGroup]="checkoutForm">
                        <div class="row">


                            <div class="col-lg-6 col-sm-12 col-xs-12">
                                <div class="checkout-title">
                                    <h3>Zahlungs Informationen</h3>
                                </div>
                                <div class="row check-out">
                                    <!-- Company Name — optional -->
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="field-label">Firma</div>
                                        <input type="text"
                                               name="companyName"
                                               [formControl]="checkoutForm.controls['companyName']"
                                               placeholder=""
                                               autocomplete="off">
                                    </div>

                                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label">Vorname *</div>
                                        <input type="text" name="firstname"
                                               [formControl]="checkoutForm.get('firstname')" placeholder=""
                                               autocomplete="off">
                                            <div *ngIf="(submitted || checkoutForm.get('firstname')?.touched) && checkoutForm.get('firstname')?.errors?.required"
                                             class="text text-danger">
                                            Vorname wird benötigt.
                                        </div>
                                        <div *ngIf="(submitted || checkoutForm.get('firstname')?.touched) && checkoutForm.get('firstname')?.errors?.pattern"
                                             class="text text-danger">
                                            Vorname darf nur Buchstaben enthalten.
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                        <div class="field-label">Nachname *</div>
                                        <input type="text" name="lastname"
                                               [formControl]="checkoutForm.controls['lastname']" value="" placeholder=""
                                               autocomplete="off">
                                        <div *ngIf="checkoutForm.controls.lastname.touched && checkoutForm.controls.lastname.errors?.required"
                                             class="text text-danger">
                                            Nachname wird benötigt.
                                        </div>
                                        <div *ngIf="checkoutForm.controls.lastname.touched && checkoutForm.controls.lastname.errors?.pattern"
                                             class="text text-danger">
                                            Nachname darf nur Buchstaben enthalten.
                                        </div>
                                    </div>
                                    <!-- Email  ⬅️  now full width -->
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="field-label">Email *</div>

                                        <input type="text"
                                               name="email"
                                               formControlName="email"
                                                placeholder=""
                                                autocomplete="off">

                                        <div *ngIf="checkoutForm.get('email')?.touched &&
                                            checkoutForm.get('email')?.errors?.required"
                                             class="text text-danger">
                                            E-Mail Adresse wird benötigt.
                                        </div>

                                        <div *ngIf="checkoutForm.get('email')?.touched &&
                                            checkoutForm.get('email')?.errors?.email"
                                            class="text text-danger">
                                            Ungültige E-Mail Adresse.
                                        </div>
                                    </div>

                                    <!--
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="field-label">Land *</div>
                                        <select name="country" [formControl]="checkoutForm.controls['country']">
                                            <option value="" selected>Wähle dein Land aus</option>
                                            <option value="Germany">Germany</option>
                                            <option value="Andere">Andere</option>
                                        </select>
                                        <div *ngIf="checkoutForm.controls.country.touched && checkoutForm.controls.country.errors?.required"
                                             class="text text-danger">
                                            Land wird benötigt.
                                        </div>
                                    </div>
                                    -->
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="field-label">Adresse *</div>
                                        <input type="text" name="address"
                                                [formControl]="checkoutForm.controls['address']" value="" placeholder=""
                                               autocomplete="off">
                                        <div *ngIf="checkoutForm.controls.address.touched && checkoutForm.controls.address.errors?.required"
                                             class="text text-danger">
                                            Adresse wird benötigt.
                                        </div>
                                        <div *ngIf="checkoutForm.controls.address.touched && checkoutForm.controls.address.errors?.maxlength"
                                             class="text text-danger">
                                            Maximal 50 Zeichen.
                                        </div>
                                    </div>
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="field-label">Stadt *</div>
                                        <input type="text" name="town" [formControl]="checkoutForm.controls['town']"
                                               value="" placeholder="" autocomplete="off">
                                        <div *ngIf="checkoutForm.controls.town.touched && checkoutForm.controls.town.errors?.required"
                                             class="text text-danger">
                                            Stadt wird benötigt.
                                        </div>
                                    </div>
                                    <!-- AGB --------------------------------------------------------------->
                                    <mat-checkbox formControlName="agb" color="primary" class="d-block my-2">
                                        Ich akzeptiere die
                                        <a routerLink="/allgemeine-geschaefts-bedingungen" target="_blank">Allgemeinen Geschäftsbedingungen (AGB)</a> *
                                    </mat-checkbox>

                                    <div *ngIf="(submitted || checkoutForm.get('agb')?.touched) &&
                                        checkoutForm.get('agb')?.errors?.required"
                                         class="text-danger mb-2">
                                        Bitte akzeptieren Sie die AGB.
                                    </div>

                                    <!-- Widerruf --------------------------------------------------------->
                                    <mat-checkbox formControlName="widerruf" color="primary" class="d-block my-2">
                                        Ich habe die
                                        <a routerLink="/faq" target="_blank">Widerrufsbelehrung</a>
                                        zur Kenntnis genommen *
                                    </mat-checkbox>

                                    <div *ngIf="(submitted || checkoutForm.get('widerruf')?.touched) &&
                                         checkoutForm.get('widerruf')?.errors?.required"
                                         class="text-danger mb-3">
                                        Bitte bestätigen Sie die Widerrufsbelehrung.
                                    </div>
                                    <p>* benötigte Informationen</p>
                                </div>
                            </div>

                            <!-- Checkout summary (right column) -->
                            <div class="col-12 col-lg-6">
                                <aside class="checkout-summary sticky-lg-top">
                                    <!-- Order summary -->
                                    <div class="card shadow-sm mb-4">
                                        <div class="card-header">
                                            <h5 class="mb-0 d-flex justify-content-between align-items-center">
                                                <span>Ihre Auswahl</span>
                                                <small class="fw-normal">Preis</small>
                                            </h5>
                                        </div>

                                        <div class="card-body p-0">
                                            <ul class="list-group list-group-flush small">
                                                <li class="list-group-item d-flex justify-content-between">
                                                    <span>Branche:</span>
                                                    <strong>{{ configState.selectedTable || 'Nicht ausgewählt' }}</strong>
                                                </li>

                                                <li class="list-group-item">
                                                    <span class="d-block">Regionen:</span>
                                                    <ng-container *ngIf="configState.selectedStates?.length; else noRegions">
                                                        <ul class="list-unstyled mb-0 ms-3">
                                                            <li *ngFor="let region of configState.selectedStates">- {{ region }}</li>
                                                        </ul>
                                                    </ng-container>
                                                    <ng-template #noRegions><strong>Nicht ausgewählt</strong></ng-template>
                                                </li>

                                                <li class="list-group-item">
                                                    <span class="d-block">Unternehmensinfos:</span>
                                                    <ng-container *ngIf="configState.selectedCompanyInfos?.length; else noInfos">
                                                        <ul class="list-unstyled mb-0 ms-3">
                                                            <li *ngFor="let info of configState.selectedCompanyInfos">- {{ info }}</li>
                                                        </ul>
                                                    </ng-container>
                                                    <ng-template #noInfos><strong>Nicht ausgewählt</strong></ng-template>
                                                </li>

                                                <li class="list-group-item d-flex justify-content-between">
                                                    <span>Anzahl Datensätze:</span>
                                                    <strong>{{ configState.selectedQuantity | number }}</strong>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="card-footer bg-light">
                                            <ul class="list-unstyled mb-0">
                                                <li class="d-flex justify-content-between mb-1">
                                                    <span>Zwischensumme</span>
                                                    <strong>{{ configState.selectedPrice | currency:'EUR':'symbol':'1.2-2' }}</strong>
                                                </li>
                                                <li class="d-flex justify-content-between fs-5 fw-bold">
                                                    <span>Total</span>
                                                    <span>{{ configState.selectedPrice | currency:'EUR':'symbol':'1.2-2' }}</span>
                                                </li>
                                                <!-- VAT information tag -->
                                                <li class="text-end">
                                                    <span class="badge bg-secondary bg-opacity-25 text-secondary">inkl. 19&nbsp;% MwSt.</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <!-- Bank transfer -->
                                    <div class="checkout-details">
                                        <div class="order-box">
                                            <h4>Banküberweisung</h4>
                                            <p>
                                                Nach Abschluss Ihres Kaufs erhalten Sie eine E-Mail mit den Zahlungsdetails.
                                                Bitte überweisen Sie den Betrag auf das angegebene Konto und geben Sie die
                                                Referenznummer aus der E-Mail im Verwendungszweck an, damit wir Ihre Zahlung
                                                korrekt zuordnen können.
                                            </p>
                                            <div class="buy-now-button-container">
                                                <button
                                                        class="btn btn-default primary-btn success radius-0 back-white"
                                                        type="button"
                                                        (click)="onSubmitBank()">
                                                    Jetzt Kaufen
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- PayPal -->
                                    <app-paypal-button
                                            [orderId]="orderId"
                                            [checkoutForm]="checkoutForm"
                                            [submitted]="submitted"
                                            [markAllAsTouched]="markAllFieldsTouched"
                                    ></app-paypal-button>

                                </aside>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</div>
